<template>
    <div class="container-fluid" style="margin-left:30px; margin-right:30px;">

        <cabecera msg="Buscar Agencias"/>

        <div class="row">
            <div class="col-md-4">
                <agency-id-input/>
                <!--
                <marca-blanca-autocompleted/>
                -->
            </div>
            <div v-show="storeAgency.id" class="col-md-8">
                <h3 class="text-center" style="margin-top:0px">{{ storeAgency.name }}</h3>
                <agency-data/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <div v-show="storeAgency.id" class="row">
                    <data-table/>
                </div>
            </div>

            <div class="col-md-8">
                <div v-show="storeHotel.id">
                    <h3 class="text-center">{{ storeHotel.name }}</h3>
                    <div class="row">
                        <data-list
                                title="Tarifas"
                                methodOptions="getRateOptionsList"
                                methodList="getRateDataList"
                                methodSave="saveRateDataList"
                        />
                    </div>

                    <div class="row">
                        <data-list
                                title="Descuentos"
                                methodOptions="getDiscountsOptionsList"
                                methodList="getDiscountsDataList"
                                methodSave="saveDiscountsDataList"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-cloak>
            <Modal
                    :show="showModal1"
                    @modal:action="handleModalAction1">

                <template v-slot:header>
                    Ignorar cambios
                </template>

                <template v-slot:body>
                    <p>
                        Hay datos pendientes de guardar:<br>
                        {{ getHasModified }}</p>
                    <p>Pulse <b>Aceptar</b> para <b>ignorar</b> los cambios</p>
                </template>
                >
            </Modal>
        </div>

    </div>
</template>

<script>

    // Test: http://localhost:8080/#/prv-direct-product
    // https://res.hotelkey.com/res/mvc.php/%5Cadmin%5Cdirect_product%5CSPA/App/#/prv-direct-product
    // https://res.hotelkey.com/reservas/mudir/index.php?context_current=775

    import Cabecera from '@/components/common/Cabecera.vue';
    import AgencyIdInput from '@/components/DirectProduct/AgencyIdInput.vue';
    //import MarcaBlancaAutocompleted from '@/components/DirectProduct/MarcaBlancaAutocompleted.vue';
    import AgencyData from '@/components/DirectProduct/AgencyData.vue';
    import DataList from '@/components/DirectProduct/DataList.vue';
    import DataTableEager from '@/components/DirectProduct/DataTableEager.vue';
    import Modal from '@/components/common/Modal.vue';

    import { mapState, mapMutations, mapGetters } from "vuex"

    export default {
        name: "DirectProduct",
        components: {
            Cabecera,
            'agency-id-input': AgencyIdInput,
            //'marca-blanca-autocompleted': MarcaBlancaAutocompleted,
            'data-list': DataList,
            'data-table': DataTableEager,
            'agency-data': AgencyData,
            Modal
        },
        data(){
            return {
                errorCode: 0,
                showModal1: false
            }
        },
        computed: {
            ...mapState('DirectProduct',['storeAgency','storeHotel','storeHasModified']),
            ...mapGetters('DirectProduct',['getHasModified']),
        },
        methods: {
            ...mapMutations('DirectProduct',['fillHasModified','storeResetState']),

            onComponentError(message) {
                this.$emit('error', message);
            },
            onComponentUpdate(data) {
                this.$emit('update', data);
            },
            handleModalAction1(response){
                this.showModal1 = false;
                this.fillHasModified({ "data": "modal", "value": 0});
                if (response == 1) {
                    this.storeResetState();
                }
            },
        },
        watch: {
            'storeHasModified.modalState': function (newVal, oldVal){
                if (newVal !== null && typeof newVal !== 'undefined' && newVal !== 0) {
                    this.showModal1 = true;
                }
            },
        },
        mounted(){
            let self = this;
            setTimeout(function () {
                self.$store.dispatch('endLoading');
            }, 1000);
        }
    }
</script>

<style scoped>
    .actions button{
        margin-right: 10px;
    }

    .status {
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 50%;
        margin-right: 5px;
    }

    .status--active {
        background: #027a02;
    }

    .status--inactive {
        background: #E50000;
    }

    [v-cloak] {
        display: none !important;
    }
</style>